import { render, staticRenderFns } from "./ZuMapSecondaryUsageFeeForBroadcastsTerms.vue?vue&type=template&id=35e8a171&scoped=true&"
import script from "./ZuMapSecondaryUsageFeeForBroadcastsTerms.vue?vue&type=script&lang=js&"
export * from "./ZuMapSecondaryUsageFeeForBroadcastsTerms.vue?vue&type=script&lang=js&"
import style0 from "./ZuMapSecondaryUsageFeeForBroadcastsTerms.vue?vue&type=style&index=0&id=35e8a171&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e8a171",
  null
  
)

export default component.exports